import mitt from 'mitt';

const KEY_RECREATE_WECHAT_LOGIN = 'KEY_RECREATE_WECHAT_LOGIN';
const KEY_MARKDOWN_RUN_CODE = 'KEY_MARKDOWN_RUN_CODE';
const KEY_MARKDOWN_RUN_CODE_RESPONSE = 'KEY_MARKDOWN_RUN_CODE_RESPONSE';
const KEY_EDITOR_GET_CODE = 'KEY_EDITOR_GET_CODE';
const KEY_EDITOR_GET_CODE_RESPONSE = 'KEY_EDITOR_GET_CODE_RESPONSE';
const KEY_PAGE_INFO = 'KEY_PAGE_INFO';
interface RunCodeParam {
  id: string;
  code: string;
}
export type PAGE_TYPE =
  | 'HOME'
  | 'TRAINING'
  | 'PROBLEM_DETAIL#OJ'
  | 'PROBLEM_DETAIL#OBJETIVE'
  | '';

export type Events = {
  [KEY_RECREATE_WECHAT_LOGIN]: undefined;
  [KEY_MARKDOWN_RUN_CODE]: RunCodeParam;
  [KEY_EDITOR_GET_CODE]: { id: string };
  [KEY_EDITOR_GET_CODE_RESPONSE]: {
    id: string;
    code: string;
    pid: number;
    title: string;
    tid: number | undefined;
    gid: number | undefined;
  };
  [KEY_PAGE_INFO]: { pageType: PAGE_TYPE };
};

// 虽然事件总线很好用
// 但是建议只用于全局事件通信，而非组件间通信
// 比如全局定时任务触发的事件或者websocket接收到特定消息触发的事件
export const EventBus = mitt<Events>();

const eventCache = new Map(); // 事件缓存

function getCache(event: string) {
  return eventCache.get(event);
}

function setCache(event: string, data: any) {
  eventCache.set(event, data);
}
function hasListener(event: keyof Events) {
  const events = EventBus.all.get(event);
  if (typeof events === 'undefined') {
    return false;
  }
  return events.length > 0;
}

// 用于更新微信登录二维码的刷新
export function recreateWechatLogin() {
  EventBus.emit(KEY_RECREATE_WECHAT_LOGIN);
}
// 需要挂在window上，用于iframe之间的调用
window.recreateWechatLogin = recreateWechatLogin;
export function recreateWechatLoginOn(fn: any) {
  EventBus.on(KEY_RECREATE_WECHAT_LOGIN, fn);
}
export function recreateWechatLoginOff() {
  EventBus.off(KEY_RECREATE_WECHAT_LOGIN);
}

// 用于markdown和运行代码之间的通信
export function runMarkdownCode(data: RunCodeParam) {
  EventBus.emit(KEY_MARKDOWN_RUN_CODE, data);
}
export function runMarkdownCodeOn(fn: (data: RunCodeParam) => void) {
  EventBus.on(KEY_MARKDOWN_RUN_CODE, fn);
}
export function runMarkdownCodeOff() {
  EventBus.off(KEY_MARKDOWN_RUN_CODE);
}
// 返回运行代码的结果：成功/失败
function getResponseKey(id: string) {
  return `${KEY_MARKDOWN_RUN_CODE_RESPONSE}_${id}` as any;
}
export function runMarkdownCodeResponse(id: string, result: boolean) {
  EventBus.emit(getResponseKey(id), result);
}
export function runMarkdownCodeResponseOn(
  id: string,
  fn: (result: boolean) => void,
) {
  EventBus.on(getResponseKey(id), fn);
}
export function runMarkdownCodeResponseOff(id: string) {
  EventBus.off(getResponseKey(id));
}
export function emitPageInfoUpdate({ pageType }: { pageType: PAGE_TYPE }) {
  EventBus.emit(KEY_PAGE_INFO, { pageType });
  if (!hasListener(KEY_PAGE_INFO)) {
    setCache(KEY_PAGE_INFO, { pageType });
  }
}
export function onPageInfoUpdate(fn: (data: { pageType: string }) => void) {
  EventBus.on(KEY_PAGE_INFO, fn);
  const cache = getCache(KEY_PAGE_INFO);
  if (cache) {
    fn(cache);
  }
}
export function offPageInfoUpdate(fn: (data: { pageType: string }) => void) {
  EventBus.off(KEY_PAGE_INFO, fn);
}
export function emitEditorGetCode(data: { id: string }) {
  EventBus.emit(KEY_EDITOR_GET_CODE, data);
}
export function onEditorGetCode(fn: (data: { id: string }) => void) {
  EventBus.on(KEY_EDITOR_GET_CODE, fn);
}
export function onEditorCodeResponse(fn: (data: { id: string }) => void) {
  EventBus.on(KEY_EDITOR_GET_CODE_RESPONSE, fn);
}
export function offEditorGetCode(fn: (data: { id: string }) => void) {
  EventBus.off(KEY_EDITOR_GET_CODE, fn);
}
export function offEditorCodeResponse(fn: (data: { id: string }) => void) {
  EventBus.off(KEY_EDITOR_GET_CODE_RESPONSE, fn);
}
export function emitEditorGetCodeResponse(
  data: Events['KEY_EDITOR_GET_CODE_RESPONSE'],
) {
  EventBus.emit(KEY_EDITOR_GET_CODE_RESPONSE, data);
}

export { KEY_EDITOR_GET_CODE, KEY_EDITOR_GET_CODE_RESPONSE };
